module.exports = __webpack_public_path__ + "static/media/Channels.f25942f2.png";